module.exports = __webpack_public_path__ + "img/logo-HLM.478e09ea.svg";